import { EButtonColorTypes, IColorSet } from './types';

export const BUTTON_COLOR_SETS: Record<EButtonColorTypes, IColorSet> = {
	[EButtonColorTypes.btn_green]: {
		colorPrimary: '#12B76A',
		colorPrimaryHover: '#027A48',
		colorPrimaryActive: '#D1FADF',
	},
	[EButtonColorTypes.btn_details]: {
		colorPrimary: '#ffbd44',
		colorPrimaryHover: '#ffcf63',
		colorPrimaryActive: '#e1a432',
	},
	[EButtonColorTypes.btn_purple]: {
		colorPrimary: '#485cc0',
		colorPrimaryHover: '#5b6cd5',
		colorPrimaryActive: '#3c4f9e',
	},
	[EButtonColorTypes.btn_cyan]: {
		colorPrimary: '#16b5bb',
		colorPrimaryHover: '#1cd0d8',
		colorPrimaryActive: '#139aa1',
	},
	[EButtonColorTypes.btn_danger]: {
		colorPrimary: '#ff4d4f',
		colorPrimaryHover: '#ff7875',
		colorPrimaryActive: '#d9363e',
	},
	[EButtonColorTypes.btn_can_clear_dispute]: {
		colorPrimary: '#6eb5be',
		colorPrimaryHover: '#82c2ca',
		colorPrimaryActive: '#5b98a4',
	},
};
